import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import BadgeIcon from "@mui/icons-material/Badge";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DownloadIcon from "@mui/icons-material/Download";
import EventIcon from "@mui/icons-material/Event";
import PaymentsIcon from "@mui/icons-material/Payments";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from "../../../utils/axios";
import { getPermissionArray } from "../../../utils/strings/userString";
import FilterTableComponent from "./FilterTableComponent";



export default function ViewInwordDividendComponent({id}){
 const permissionArray = getPermissionArray();
  const { t } = useTranslation();
    const [isLoading, setIsLoding] =useState(true)
    const [isSuccess, setIsSuccess] =useState(false)
    const [data, setData] = useState("")
    const [apiData, setApiData] = useState([])
   

    const params = useParams();

    const dividendId = id || params.id;
   

    useEffect(() => {

        axios.get(`inward-dividend/${dividendId}`)
        .then((res) =>{
            if(res.data.success){
                setIsSuccess(true)
                setIsLoding(false)
                setData(res.data.payload)
            }
        })
        .catch((err) =>{
            alert("There was an error occured!")
        })
        // axios.get(`/bank-bo/list`)
        // .then((res) =>{
        //     if(res.data.success){
        //       setApiData(res.data.payload)
        //     }
        // })
        // .catch((err) =>{
        //     alert("There was an error occured!")
        // })
      }, [dividendId]);

      const pdfDownloadHandler = (id) => {
        axios({
          url: `inward-dividend/application/${dividendId}`, //your url
          method: 'GET',
          responseType: 'blob', // important
      })
      .then((response) =>{
        //setLoader(false)
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `dividend_details_${dividendId}.PDF`);
        document.body.appendChild(link);
        link.click();
        //window.open(url);
        //link.remove();
      })
      .catch((error) =>{
        //setLoader(false);
        //setError(error.message);
        alert("There was an error ocurred!")
      })
  };
      
// console.log(apiData);
// console.log(apiData);


    //   let content = "";
    //   // content = <div 
    //   //  style={{display: 'flex',flexDirection: 'row'}}
    //   // > 
    //   content = <Grid container spacing={4}>
      
    //   <Grid item lg={6} md={6} sm={12} xs={12}>
    //     <Paper 
    //     // style={{display: 'flex',flexDirection: 'row',margin: '7px',width: '48%',borderRadius: 20, borderColor: 'black'}}
    //     >
    //         <Table size='small'>
    //           <TableHead>
    //           <TableRow>
    //               <TableCell style={{dispaly: "flex" , fontSize:"20px", backgroundColor:"#96B6C5",}}></TableCell>
    //               <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"20px", backgroundColor:"#96B6C5",}}>Basic Information</TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
                
    //             <TableRow>
    //               <TableCell>ID:</TableCell>
    //               <TableCell>{data.autoId}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Uploaded on</TableCell>
    //               <TableCell>{data.date}</TableCell>
    //             </TableRow>
            
    //             <TableRow>
    //               <TableCell>Dividend Type</TableCell>
    //               <TableCell>{data.dividendType}</TableCell>
    //             </TableRow>

    //             <TableRow>
    //               <TableCell>Dividend Year</TableCell>
    //               <TableCell>{data.year}</TableCell>
    //             </TableRow>
                
    //             <TableRow>
    //               <TableCell>REF</TableCell>
    //               <TableCell>{data.ref}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Remarks</TableCell>
    //               <TableCell>{data.remarks}</TableCell>
    //             </TableRow>
            

    //           </TableBody>
    //         </Table>
    //     </Paper>
    //     </Grid>
    //     <Grid item lg={6} md={6} sm={12} xs={12}>
    //       <Paper 
    //       // style={{display: 'flex',flexDirection: 'row',margin: '7px',width: '48%',borderRadius: 20}}
    //       >
    //         <Table size='small'>
    //           <TableHead>
    //           </TableHead>
    //           <TableBody>
    //       <TableRow>
    //               <TableCell style={{dispaly: "flex" , fontSize:"18px", backgroundColor:"#96B6C5",}}></TableCell>
    //               <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"18px", backgroundColor:"#96B6C5",}}>Cash Dividend (BDT)</TableCell>
    //             </TableRow>

    //             <TableRow>
    //               <TableCell>Total Cash</TableCell>
    //               <TableCell>{data.total_cash}</TableCell>
    //             </TableRow>

    //             {/* cash_9_1 */}
    //             <TableRow>
    //               <TableCell>Cash Dividend</TableCell> 
    //               <TableCell>{data.cash_9_1}</TableCell>
    //             </TableRow>

    //             {/* cash_9_4 */}
    //             <TableRow>
    //               <TableCell>IPO</TableCell>
    //               <TableCell>{data.cash_9_4}</TableCell>
    //             </TableRow>

    //             {/* <TableRow>
    //               <TableCell>Total Foreign Currency</TableCell>
    //               <TableCell>{data.total_fc}</TableCell>
    //             </TableRow> */}

    //   <TableRow>
    //               <TableCell style={{dispaly: "flex" , fontSize:"18px", backgroundColor:"#96B6C5",}}></TableCell>
    //               <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"18px", backgroundColor:"#96B6C5",}}>FC Dividend (USD)</TableCell>
    //             </TableRow>

    //             <TableRow>
    //               <TableCell>Total Cash</TableCell>
    //               <TableCell>{data.total_fc}</TableCell>
    //             </TableRow>

    //             {/* cash_9_1 */}
    //             <TableRow>
    //               <TableCell>Cash Dividend</TableCell> 
    //               {/* <TableCell>{data.cash_9_1}</TableCell> */}
    //               <TableCell>{0}</TableCell>
    //             </TableRow>

    //             {/* cash_9_4 */}
    //             <TableRow>
    //               <TableCell>IPO</TableCell>
    //               {/* <TableCell>{data.cash_9_4}</TableCell> */}
    //               <TableCell>{0}</TableCell>
    //             </TableRow>

    //             {/* fc_9_1
    //             <TableRow>
    //               <TableCell>IPO</TableCell>
    //               <TableCell>{data.fc_9_4}</TableCell>
    //             </TableRow> */}
    //             <TableRow>
    //               <TableCell style={{dispaly: "flex" , fontSize:"20px", backgroundColor:"#96B6C5",}}></TableCell>
    //               <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"18px", backgroundColor:"#96B6C5",}}>Stock Dividend</TableCell>
    //             </TableRow>

    //             {/* stock_9_2 + stock_9_3  */}
    //             <TableRow>
    //               <TableCell>Total Share</TableCell>
    //               <TableCell>{(data.stock_9_2)+(data.stock_9_3)}</TableCell>
    //             </TableRow>

    //             {/* stock_9_2 */}
    //             <TableRow>
    //               <TableCell>Bonus Share</TableCell>
    //               <TableCell>{data.stock_9_2}</TableCell>
    //             </TableRow>

    //             {/* stock_9_3 */}
    //             <TableRow>
    //               <TableCell>Right Share</TableCell>
    //               <TableCell>{data.stock_9_3}</TableCell>
    //             </TableRow>
    //             </TableBody>
    //         </Table>
    //       </Paper>
    //       </Grid>


    // {/* <h1 style={{marginBottom: "50px"}}> </h1></div>; */}
    // <h1 style={{marginBottom: "20px"}}> </h1>
    // </Grid>;

    const InfoRow = ({ label, value }) => (
  <Stack
    direction="row"
    justifyContent="space-between"
    alignItems="center"
  >
    <Typography color="text.secondary">
      {label}
    </Typography>

    <Typography
      fontWeight={700}
      sx={{
        // bgcolor: "#f5f5f5",
        px: 2,
        py: 0.5,
        borderRadius: 2,
      }}
    >
      {value}
    </Typography>
  </Stack>
);
const DetailsCard = ({ title, children }) => (
  <Card
    sx={{
      borderRadius: 4,
      height: "100%",
      boxShadow: "0 8px 20px rgba(0,0,0,.06)",
    }}
  >
    <CardContent>
      <Typography
        variant="h6"
        fontWeight={700}
      >
        {title}
      </Typography>

      <Stack spacing={2}>
        {children}
      </Stack>
    </CardContent>
  </Card>
);

const SummaryCard = ({ title, value, color, icon }) => (
  <Card
    sx={{
      borderRadius: 4,
      transition: ".3s",
      cursor: "pointer",
      boxShadow: "0 10px 25px rgba(0,0,0,.08)",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "0 20px 40px rgba(0,0,0,.15)",
      },
    }}
  >
    <CardContent>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Typography style={{textAlign:"left"}} color="text.secondary">
            {title}
          </Typography>

          <Typography
            variant="h4"
            fontWeight={700}
            sx={{
              color,
            }}
          >
            {value}
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: color,
            color: "#fff",
            borderRadius: "50%",
            p: 1.5,
          }}
        >
          {icon}
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

const InfoHeaderCard = ({ icon, title, value, color }) => (
  <Card
    elevation={0}
    sx={{
      borderRadius: 4,
      border: "1px solid #e8ecf2",
      transition: "all .3s ease",
      cursor: "pointer",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "0 18px 35px rgba(0,0,0,.10)",
      },
    }}
  >
    <CardContent>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 50,
            height: 50,
            borderRadius: "50%",
            bgcolor: `${color}20`,
            color,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {icon}
        </Box>

        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ letterSpacing: 1 }}
          >
            {title}
          </Typography>

          <Typography
            variant="h6"
            fontWeight={700}
          >
            {value}
          </Typography>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

    let content = "";
    // working one currently
    // content = (
    //   <div style={{ padding: '10px' }}> 
    //     <Paper 
    //       style={{
    //         display: 'flex',
    //         flexDirection: 'row',
    //         flexWrap: 'wrap',
    //         margin: '7px',
    //         width: '90%',
    //         borderRadius: 20,
    //         borderColor: 'black',
    //       }}
    //     >
    //       <div style={{ flex: '1 1 48%', margin: '1%' }}>
    //         <Table size='small'>
    //           <TableHead>
    //             <TableRow>
    //               <TableCell 
    //                 style={{
    //                   fontSize: "20px", 
    //                   backgroundColor: "#96B6C5",
    //                 }}
    //               />
    //               <TableCell 
    //                 style={{
    //                   fontSize: "20px", 
    //                   backgroundColor: "#96B6C5",
    //                   textAlign: "left",
    //                 }}
    //               >
    //                 Basic Information
    //               </TableCell>
    //             </TableRow>
    //           </TableHead>
    //           <TableBody>
    //             <TableRow>
    //               <TableCell>ID:</TableCell>
    //               <TableCell>{data.autoId}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Payment Date</TableCell>
    //               <TableCell>{data.date}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Dividend Type</TableCell>
    //               <TableCell>{data.dividendType}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Dividend Year</TableCell>
    //               <TableCell>{data.year}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>REF</TableCell>
    //               <TableCell>{data.ref}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Remarks</TableCell>
    //               <TableCell>{data.remarks}</TableCell>
    //             </TableRow>
    //           </TableBody>
    //         </Table>
    //       </div>
    
    //       <div style={{ flex: '1 1 48%', margin: '1%' }}>
    //         <Table size='small'>
    //           <TableBody>
    //             <TableRow>
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                 }}
    //               />
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                   textAlign: "left",
    //                 }}
    //               >
    //                 Cash Dividend (BDT)
    //               </TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Total Cash</TableCell>
    //               <TableCell>{data.total_cash}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Cash Dividend</TableCell> 
    //               <TableCell>{data.cash_9_1}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>IPO</TableCell>
    //               <TableCell>{data.cash_9_4}</TableCell>
    //             </TableRow>
    
    //             <TableRow>
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                 }}
    //               />
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                   textAlign: "left",
    //                 }}
    //               >
    //                 FC Dividend (USD)
    //               </TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Total Cash</TableCell>
    //               <TableCell>{data.total_fc}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Cash Dividend</TableCell> 
    //               <TableCell>{0}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>IPO</TableCell>
    //               <TableCell>{0}</TableCell>
    //             </TableRow>
    
    //             <TableRow>
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                 }}
    //               />
    //               <TableCell 
    //                 style={{
    //                   fontSize: "18px", 
    //                   backgroundColor: "#96B6C5",
    //                   textAlign: "left",
    //                 }}
    //               >
    //                 Stock Dividend
    //               </TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Total Share</TableCell>
    //               <TableCell>{(data.stock_9_2)+(data.stock_9_3)}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Bonus Share</TableCell>
    //               <TableCell>{data.stock_9_2}</TableCell>
    //             </TableRow>
    //             <TableRow>
    //               <TableCell>Right Share</TableCell>
    //               <TableCell>{data.stock_9_3}</TableCell>
    //             </TableRow>
    //           </TableBody>
    //         </Table>
    //       </div>
    //     </Paper>
    //     {/* <h1 style={{ marginBottom: "10px" }} /> */}
    //   </div>
    // );
    content = (
      <Box
        sx={{
          p: 4,
          bgcolor: "#f5f7fb",
          minHeight: "100vh",
          borderRadius: 4,
        }}
      >
        {/* Header */}

        <Typography
          variant="h4"
          fontWeight={700}
          mb={1}
          textAlign="center"
        >
          {data.issuer?.name}
        </Typography>

        {/* Top Info */}

        {/* <Stack
          direction="row"
          spacing={2}
          flexWrap="wrap"
          mb={4}
        >
          <Chip label={`ID : ${data.autoId}`} color="primary" />
          <Chip
            icon={<CalendarMonthIcon />}
            label={data.date}
            color="secondary"
          />
          <Chip label={data.dividendType} color="success" />
          <Chip label={`Year : ${data.year}`} />
        </Stack> */}
        <Grid container spacing={1} mb={1}>
          <Grid item xs={12} sm={6} md={3}>
            <InfoHeaderCard
              icon={<BadgeIcon />}
              title="ID"
              value={data.autoId}
              color="#1976d2"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <InfoHeaderCard
              icon={<CalendarMonthIcon />}
              title="Payment Date"
              value={new Date(data.date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })}
              color="#43a047"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <InfoHeaderCard
              icon={<AccountTreeIcon />}
              title="Dividend Type"
              value={data.dividendType}
              color="#fb8c00"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <InfoHeaderCard
              icon={<EventIcon />}
              title="Dividend Year"
              value={data.year}
              color="#8e24aa"
            />
          </Grid>
        </Grid>

        {/* Summary Cards */}

        <Grid container spacing={1} mb={1}>
          <Grid item xs={12} md={4}>
            <SummaryCard
              title="Total Cash"
              value={`৳ ${data.total_cash}`}
              color="#2e7d32"
              icon={<PaymentsIcon />}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <SummaryCard
              title="FC Dividend"
              value={`$ ${data.total_fc}`}
              color="#1565c0"
              icon={<CurrencyExchangeIcon />}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <SummaryCard
              title="Total Shares"
              value={data.stock_9_2 + data.stock_9_3}
              color="#ef6c00"
              icon={<TrendingUpIcon />}
            />
          </Grid>
        </Grid>

        {/* Details */}

        <Grid container spacing={1}>
          <Grid item xs={12} md={6} lg={4}>
            <DetailsCard title="Cash Breakdown">
              <InfoRow
                label="Cash Dividend"
                value={data.cash_9_1}
              />
              <Divider />
              <InfoRow
                label="IPO"
                value={data.cash_9_4}
              />
            </DetailsCard>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <DetailsCard title="FC Breakdown">
              <InfoRow
                label="Cash Dividend"
                value={0}
              />
              <Divider />
              <InfoRow
                label="IPO"
                value={0}
              />
            </DetailsCard>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <DetailsCard title="Stock Breakdown">
              <InfoRow
                label="Bonus Share"
                value={data.stock_9_2}
              />
              <Divider />
              <InfoRow
                label="Right Share"
                value={data.stock_9_3}
              />
            </DetailsCard>
          </Grid>

          <Grid item xs={12} md={12} lg={12}>
            <DetailsCard title="Additional Information">
              <InfoRow label="Reference" value={data.ref} />
              <Divider />
              <InfoRow label="Remarks" value={data.remarks || "-"} />
            </DetailsCard>
          </Grid>
        </Grid>
      </Box>
    );




let content2 = "";
content2 = <div> <Paper>
                  <Table>
                    <TableHead>
                      <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"24px", backgroundColor:"#9DC08B",}}></TableCell>
                      <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"24px", backgroundColor:"#9DC08B",}}></TableCell>
                      <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"24px", backgroundColor:"#9DC08B",}}>Details of Uploaded Excel Files</TableCell>
                      <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"24px", backgroundColor:"#9DC08B",}}>{apiData.companyName}</TableCell>
                      <TableCell style={{dispaly: "flex" ,textAlign: "leftalign", fontSize:"24px", backgroundColor:"#9DC08B",}}></TableCell>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>File Name</TableCell>
                            <TableCell>Dividend Type</TableCell>
                          
                            <TableCell>Date of Upload</TableCell>
                            <TableCell>Download</TableCell>        
                        </TableRow>
                        <TableRow>
                            <TableCell>1</TableCell>
                            <TableCell>demo_investor_file_1</TableCell>
                            <TableCell>cash</TableCell>
                            <TableCell>21-05-2023</TableCell>
                            <TableCell>
                              <Button style={{backgroundColor:"#A4BE7B"}}>
                                hi
                              </Button>
                            </TableCell>
                        </TableRow>  
                        <TableRow>
                            <TableCell>2</TableCell>
                            <TableCell>demo_investor_file_2</TableCell>
                            <TableCell>stock</TableCell>
                            
                            <TableCell>21-05-2023</TableCell>
                            <TableCell>
                              <Button style={{backgroundColor:"#A4BE7B"}}>
                              hi
                              </Button>
                            </TableCell>
                        </TableRow>    
                    </TableBody>
                  </Table>
                </Paper>

<h1 style={{marginBottom: "50px"}}> </h1></div>;


    return(
        // <div>
        //   <PageTitle title={`${t('inwardDividend.view.pageTitle')}`}
        //    button={
        //   <Link to="/app/inward-dividend/list"> 
        //     <Button
        //       variant="contained"
        //       size="medium"
        //       color="primary">
        //           { t('inwardDividend.view.listLink')}
        //     </Button>
        //   </Link>}  />


        //     {isSuccess && content}
        //     {/* {isSuccess && content2} */}
        //   <Button 
        //       // disabled={!permissionArray.includes("Inward-Dividend-list-sub-file-upload")}
        //       style={{margin: "25px"}}
        //       variant="contained"
        //       size="medium"
        //       color="primary"
        //       onClick={pdfDownloadHandler}>
        //         Downlod Copy
        //   </Button>
        //     <FilterTableComponent id={dividendId}  />
            
        // </div>
        <Box sx={{ p:2, minHeight: "100vh" }}>
  {/* Header */}
  <Paper
    elevation={0}
    sx={{
      backgroundColor: "transparent",
      p: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 2,
    }}
  >
    <PageTitle title={t("inwardDividend.view.pageTitle")} />

    <Stack direction="row" spacing={2}>
      <Button
        variant="outlined"
        startIcon={<DownloadIcon />}
        onClick={pdfDownloadHandler}
        sx={{
          borderRadius: 3,
        }}
        color="primary"
      >
        Download Copy
      </Button>

      <Button
        component={Link}
        to="/app/inward-dividend/list"
        variant="contained"
        sx={{
          borderRadius: 3,
        }}
        color="primary"
      >
        {t("inwardDividend.view.listLink")}
      </Button>
    </Stack>
  </Paper>

  {isSuccess && content}

  <Box mt={4}>
    <FilterTableComponent id={dividendId} />
  </Box>
</Box>
    )
}